import { connect, history, useHistory } from 'umi';
import React, { useEffect, useMemo, useState } from 'react';
import type { BadgeProps } from 'antd-mobile/es/components/badge';
import TabBarLayout from '../../layouts/tab-bar';
import './index.less';
import TopNavBar from './header';
import PageFooter from './footer';
import {qureyDetection} from '../../api/service'
import { IsPC, ParseURIParam, ParseURIParamStr } from '@/utils/utils';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Bounced from '../../components/bounced';
import { routesMap } from '@/utils/routeMap';
// import FloatingBubbleCustom from '@/components/floatingBubble';
import CryptoJS from 'crypto-js';
import NoticeBarHoliday from '@/components/noticeBar';
import '@/utils/drift';
import WarningPopup from '@/components/pcWarningPopup';
import useSorryPop from '@/components/otherWebInPopup/useSorryPop'
import {Tabs} from 'antd-mobile'
export interface TabBarItemValueProps {
  homeBadge?: BadgeProps['content'];
  todoBadge?: BadgeProps['content'];
  messageBadge?: BadgeProps['content'];
  meBadge?: BadgeProps['content'];
}

function mapPCURLtoMobile() {
  const firstName = ParseURIParam(0);
  const secondName = ParseURIParam(1);
  const thirdName = ParseURIParam(2);
  if(firstName == 'shop' &&
     secondName == 'product'){
    history.push('/p?id='+thirdName);
  }else if(firstName == 'shop' &&
           secondName == 'category-product'){
    // history.push('/c/all');
    history.push('/');
  }else{

  }
  
}

mapPCURLtoMobile();

// const query = this.props.match.location.search
// let pcURL = '';
// const urlParams = genPcParams();
// if (process.env.UMI_ENV == 'production') {
//   pcURL = 'https://modcart.com' + urlParams;
// } else {
//   pcURL = 'https://test.modcart.com' + urlParams;
// }

// 根据前进还是后退显示不同的转场动画效果
const ANIMATION_MAP: any = {
  PUSH: 'forward',
  POP: 'back',
};



//底部导航状态管理
export const TabBarContext = React.createContext<{
  items: TabBarItemValueProps;
  callback?: (values: TabBarItemValueProps) => void;
}>({
  items: {},
});

/**
 * 不同的全局 layout
 * @param props
 * @url https://umijs.org/zh-CN/docs/convention-routing#%E4%B8%8D%E5%90%8C%E7%9A%84%E5%85%A8%E5%B1%80-layout
 */
const MyLayout = (props: any) => {
  const { dispatch, BouncedFlag, pageScroll, warningPopup,loginInfo } = props;
  useEffect(()=>{
    dispatch({
      type:'headInfo/changeModel',
      payload:{model:'living'}
    })
  },[])
  const h = useHistory();
  const record = (e) => {
    const url = h.location.pathname + h.location.search;
    console.log('then--监听路由', url, window.scrollY, pageScroll);
    dispatch({
      type: 'categoryData/changePageScroll',
      payload: { url: url, scroll_pos: window.scrollY },
    });
  };

  const hi = history.block((e) => record(e));
  useEffect(() => {
    hi();
  }, []);

  //弹框逻辑
  const checkShowSorryPop =async (dc:any,props:any,path:any) => {
    const res:any = await qureyDetection({activityCode:dc})
    
    useSorryPop({...props,sorrypop:res,path})
  }
  useEffect(()=>{
    const dc = h.location.query.dc
    const path = h.location.pathname
    if(loginInfo.login != undefined){
      checkShowSorryPop(dc,props,path)
    }
  },[loginInfo.login])
  const [taBarItemValues, setTabBarItemValues] = useState<
    TabBarItemValueProps | any
  >({});
  //底部导航栏getLayoutChildren
  const getLayoutChildren = useMemo(() => {
    if (props.location.pathname.includes('/tabBar/')) {
      console.log('====== TabBarLayout ======');
      return <TabBarLayout {...props}>{props.children}</TabBarLayout>;
    }
    console.log('basic-layout-warp');
    return <div className="basic-layout-warp">{props.children}</div>;
  }, [props]);
  //头部navbar显示隐藏判断
  const getTopNavBarLayoutChildren = useMemo(() => {
    if (props.location.pathname.includes('/c/')) {
      return (
        <div className="big_box">
          <WarningPopup warningPopup={warningPopup}/>
          {/* <InvitePopup /> */}
          <TopNavBar />
          {
            loginInfo?.announcement?.id&&
            <NoticeBarHoliday />
          }
          {props.children}
          {/* {
            props.location.pathname.includes('myCart')?<PageFooter bottom={true}/>:<PageFooter bottom={false}/>
          } */}
        </div>
      );
    } else if (routesMap.get(props.location.pathname.toLocaleLowerCase())?.header) {
      console.log('====== nav ======');
      return (
        <div className="big_box">
          <WarningPopup warningPopup={warningPopup}/>
          {/* <InvitePopup /> */}
          <TopNavBar />
          {
            loginInfo?.announcement?.id&&
            <NoticeBarHoliday />
          }
          {props.children}
          {
            (props.location.pathname.includes('coupons')||props.location.pathname.includes('everyday-extras'))?null:<PageFooter bottom={true}/>
          }
        </div>
      );
    }
    console.log('basic-layout-warp');
    return (
      <div className="basic-layout-warp">
        <WarningPopup warningPopup={warningPopup}/>
        {/* <InvitePopup /> */}
        {props.children}
        {/* <FloatingBubbleCustom /> */}
      </div>
    );
  }, [props]);

  const customFun = () => {
    console.log(
      'then---animate----customFun',
      window.scrollY,
      window.scrollbars.visible,
    );
  };

  const entered = () => {
    console.log(
      'then---animate----entered',
      props.history.action,
      pageScroll,
      window.scrollY,
    );
  };
  const exited = () => {
    const url = h.location.pathname + h.location.search;
    console.log('then---animate----exited', pageScroll.get(url));
    if (
      (h.location.pathname === '/' || h.location.pathname.toLocaleLowerCase() === '/everydayextras'||h.location.pathname.toLocaleLowerCase() === '/theme'||
        h.location.pathname.includes('/c/') ||
        h.location.pathname === '/s') &&
      props.history.action === 'POP'
    ) {
      window.scrollTo({ top: pageScroll.get(url) || 0 });
    } else {
      window.scrollTo({ top: 0 });
    }
  };


  return (
    // <TabBarContext.Provider
    //     value={{
    //         items: taBarItemValues,
    //         callback: (items) => setTabBarItemValues({ ...items }),
    //     }}
    // >
    <div>
      <TransitionGroup
        childFactory={(child: any) =>
          React.cloneElement(child, {
            classNames: ANIMATION_MAP[props.history.action],
          })
        }
      >
        <CSSTransition
          key={props.location.pathname}
          timeout={300}
          // unmountOnExit={false}
          onExited={exited}
          addEndListener={customFun}
          onEntered={entered}
        >
          <div className="global-layout">
            {getTopNavBarLayoutChildren}
          </div>
        </CSSTransition>
      </TransitionGroup>
      {BouncedFlag ? <Bounced /> : ''}
    </div>

    // </TabBarContext.Provider>
  );
};

export default connect(({ homeData, headInfo, categoryData }: any) => {
  return {
    ...homeData,
    ...headInfo,
    ...categoryData,
  };
})(MyLayout);
